import Heading from 'LuxKit/Typography/Heading'
import React from 'react'

export function UnfilteredResults() {
  return (
    <Heading colour="neutral-eight" variant="heading1">
      Travel inspiration
    </Heading>
  )
}
